import { render } from "./Subscribers.vue?vue&type=template&id=da4b4546&scoped=true"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"

import "./Subscribers.vue?vue&type=style&index=0&id=da4b4546&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4b4546"]])

export default __exports__